import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoIsForSection() {
  const forWho = ['Mujeres hispanas entre 45 y 55 años con sofocos nocturnos frecuentes.', 'Quienes buscan una solución natural sin hormonas ni pastillas.', 'Aquellas que quieren dormir de corrido toda la noche y despertar con energía.', 'Mujeres dispuestas a ajustar su alimentación nocturna.', 'Quienes prefieren seguir una guía clara y paso a paso.'];
  const notForWho = ["Quienes buscan una 'píldora mágica' sin hacer cambios de hábitos.", 'Mujeres que no están dispuestas a probar técnicas de respiración.', 'Quienes prefieren tratamientos farmacológicos tradicionales.', 'Personas que no tienen problemas de sueño relacionados con el calor.'];
  return <section className="py-20 bg-slate-50" data-id="element-134">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-135">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-136">
          {/* Is For */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-200" data-id="element-137">
            <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center" data-id="element-138">
              <span className="bg-green-100 text-green-700 p-2 rounded-full mr-3" data-id="element-139">
                <Check className="w-6 h-6" data-id="element-140" />
              </span>
              Esto es PARA TI si...
            </h3>
            <ul className="space-y-4" data-id="element-141">
              {forWho.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-142">
                  <Check className="w-5 h-5 text-green-500 mr-3 mt-1 flex-shrink-0" data-id="element-143" />
                  <span className="text-slate-700 text-lg" data-id="element-144">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For */}
          <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-200 opacity-90" data-id="element-145">
            <h3 className="text-2xl font-bold text-slate-900 mb-8 flex items-center" data-id="element-146">
              <span className="bg-red-100 text-red-700 p-2 rounded-full mr-3" data-id="element-147">
                <X className="w-6 h-6" data-id="element-148" />
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-149">
              {notForWho.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-150">
                  <X className="w-5 h-5 text-red-400 mr-3 mt-1 flex-shrink-0" data-id="element-151" />
                  <span className="text-slate-600 text-lg" data-id="element-152">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}